module.exports = __webpack_public_path__ + "static/img/about-list3.32bdfcf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about-list3.png
// module id = TtAn
// module chunks = 0